// Import Custom Conponents
import Greeting from "./components/Greeting"
import Slideshow from "./components/Slideshow"
import Projects from "./components/Projects"
import Capabilities from "./components/Capabilities"
import Gallery from "./components/Gallery"
import People from "./components/People"
import Menu from "./components/Menu"
import FadeIn from "./components/FadeIn"


// Initialise our components on jQuery.ready…
jQuery(function ($) {

  // // Slick slider
  Greeting.init()
  Slideshow.init()
  Projects.init()
  Capabilities.init()
  Gallery.init()
  People.init()
  Menu.init()
  FadeIn.init()

});



// ;(function(){
//     function id(v){ return document.getElementById(v); }
//     function section(v){ return document.getElementsByClassName(v); }
//     function topConent(v){ return document.getElementsByClassName(v); }
//     function loadbar() {
//       var ovrl = id("loader"),
//           prog = id("progress"),
//           page = id("page"),
//           sections = section("preload"),
//           top = topConent("bg"),
//           img = document.images,
//           c = 0,
//           tot = img.length;
//       if(tot == 0) return doneLoading();
//       function imgLoaded(){
//         c += 1;
//         var perc = ((100/tot*c) << 0) +"%";
//         prog.style.width = perc;
//         //stat.innerHTML = "Loading "+ perc;
//         if(c===tot) return doneLoading();
//       }
//       function doneLoading(){
//         ovrl.classList.add('hide');
//         page.classList.add('active');
//         for (var i = 0; i < sections.length; i++) {
//           sections[i].classList.add('active');
//         }
//         for(var i = 0; i < top.length; i++){  
//           let _top = top[i];        
//           let img = _top.dataset.img;
//           _top.classList.add('active');
//           _top.style.backgroundImage = 'url('+img+')';
//           // setTimeout(function(){
//           // }, 500*(1+1));
//         }
//       }
//       for(var i=0; i<tot; i++) {
//         var tImg     = new Image();
//         tImg.onload  = imgLoaded;
//         tImg.onerror = imgLoaded;
//         tImg.src     = img[i].src;
//       }    
//     }
//     document.addEventListener('DOMContentLoaded', loadbar, false);
//   }());